<template>
    <div class="x_box A4">
        <div class="x_body">
            <div class="print-header font-m">
                <h2 class="text-center" style="font-weight: bold;">{{company.Name}}</h2>
                <p class="text-center">{{$now().format('DD/MM/YYYY HH:mm A')}}</p>
                <h3 class="text-center">{{$t('stock_in')}}</h3>
            </div>
            <div class="row">
                <div class="col-sm-6">
                    <table class="table-print">
                        <tbody>
                            <tr>
                                <td style="width: 100px;">{{ $t('branch_name') }}</td>
                                <td style="width: 15px;">:</td>
                                <td>{{branch.Name}}</td>
                            </tr>
                            <tr>
                                <td>{{ $t('receiver') }}</td>
                                <td>:</td>
                                <td>{{employee.KhmerName}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="col-sm-6">
                    <table class="table-print" align="right">
                        <tbody>
                            <tr>
                                <td style="width: 100px;">{{ $t('invoice_no') }}</td>
                                <td style="width: 15px;">:</td>
                                <td style="min-width: 150px;">{{stockin.InvoiceNo}}</td>
                            </tr>
                            <tr>
                                <td>{{$t('date')}}</td>
                                <td>:</td>
                                <td>{{$format(stockin.InDateAt, 'DD/MM/YYYY')}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <br/>
            <div class="row">
                <div class="col-sm-12">
                    <table class="table table-bordered table-sm no-bor">
                        <thead>
                            <tr>
                                <th>{{$t('no')}}</th>
                                <th>{{$t('item_name')}}</th>
                                <th>{{$t('description')}}</th>
                                <th class="text-center">{{$t('qty')}}</th>
                                <th class="text-center">{{$t('qty_in')}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(ret, index) in lines" :key="index">
                                <td>{{index + 1}}</td>
                                <td>{{ret.ItemName}}</td>
                                <td>{{ret.Description}}</td>
                                <td class="text-center">{{ret.Quantity}}</td>
                                <td class="text-center">{{ret.QuantityIn}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                company: {},
                stockin: {},
                lines: [],
                branch: {},
                employee: {}
            }
        },
        created() {
            this.getCompany();
            var id = this.$route.params.id;
            if(id != undefined && id != null && id != ''){
                this.findById(id);
            }
        },
        methods: {
            getCompany: function() {
                this.$api().post("company").then(res => {
                    this.company = res.data.Data;
                });
            },
            findById(id){
                var loading = this.$loading.show();
                this.$api().post('stockin/find', { Id: id }).then(res => {
                    if(this.$isValid(res)){
                        var data = res.data.Data;
                        this.stockin = data.StockIn;
                        this.branch = data.Branch;
                        this.employee = data.Employee;
                        this.lines = data.StockInLines;
                    }
                }).finally(function() { loading.hide(); });
            }
        }
    }
</script>